import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import Webcam from "react-webcam";
import { Modal } from "react-bootstrap";
import { InputFile } from "../../../partials/form/components/fields/InputFile";
import { toastfy } from "../../../partials/toast/Toast";

interface CameraProps {
  onPictureCapture: (picture: string | Blob) => void;
  className?: string;
  clearPicture?: boolean;
  setClearPicture?: Dispatch<SetStateAction<boolean>>;
  removeBorder?: boolean; // 🟢 Nova propriedade para controlar a borda dinamicamente
}

const WebCamPicture: React.FC<CameraProps> = ({
  onPictureCapture,
  className,
  clearPicture,
  setClearPicture,
  removeBorder = false, // 🟢 Padrão como falso para não quebrar outros lugares
}) => {
  const webcamRef = useRef<any>(null);
  const [capturedImage, setCapturedImage] = useState<Blob | null>(null);
  const [showCamera, setShowCamera] = useState<boolean>(false);
  const [modalCamera, setModalCamera] = useState(false);
  const [optionsModal, setOptionsModal] = useState(true);

  const toggleContent = (buttonType: any) => {
    if (buttonType === "take-picture") {
      setOptionsModal(true);
      setShowCamera(true);
    } else {
      setOptionsModal(false);
      setShowCamera(false);
    }
  };

  const handleSelectImage = (image: any) => {
    setCapturedImage(image);
    onPictureCapture(image);
  };

  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();

      if (imageSrc) {
        fetch(imageSrc)
          .then((res) => res.blob())
          .then((blob) => {
            setCapturedImage(blob);
            onPictureCapture(blob);
          })
          .catch((error) => {
            console.error(error);
          });

        setShowCamera(false);
        setModalCamera(false);
      }
    }
  };

  const uploadImage = () => {
    if (!capturedImage) {
      toastfy("error", "Nenhuma imagem inserida!");
    } else {
      setModalCamera(false);
    }
  };

  const openCamera = () => {
    setShowCamera(true);
    setModalCamera(true);
    setOptionsModal(true);
  };

  const deleteImage = () => {
    setCapturedImage(null);
    onPictureCapture("");
  };

  useEffect(() => {
    if (clearPicture && capturedImage) {
      setCapturedImage(null);
      if (setClearPicture) {
        setClearPicture(false);
      }
    }
  }, [clearPicture, capturedImage, setClearPicture]);

  return (
    <>
      <div className={className}>
        <div>
          {capturedImage ? (
            <div className="col">
              <img
                src={
                  capturedImage instanceof Blob
                    ? URL.createObjectURL(capturedImage)
                    : ""
                }
                alt="img-visitor"
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "7em",
                  // 🟢 Se removeBorder for true, removemos a borda branca (border: "none")
                  border: removeBorder ? "none" : "5px solid white",
                }}
              />
            </div>
          ) : (
            <div className="col">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="currentColor"
                className="bi bi-person-circle"
                viewBox="0 0 16 16"
              >
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                <path
                  fillRule="evenodd"
                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                />
              </svg>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end align-items-center gap-2 w-100">
          {!showCamera && (
            <button
              className="btn btn-primary btn-sm text-white"
              onClick={openCamera}
              title="Abrir Camera"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                className="bi bi-camera"
                viewBox="0 0 16 16"
              >
                <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z" />
                <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
              </svg>
            </button>
          )}
          {capturedImage && (
            <div className="">
              <button
                className="btn btn-sm btn-danger"
                title="Excluir Imagem"
                onClick={deleteImage}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="currentColor"
                  className="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>

      <div>
        <Modal show={modalCamera} className="bg-black" style={{ zIndex: 1080 }}>
          <div className="d-flex justify-content-center align-items-center w-100 border-bottom pt-3 pb-3 pe-3 ps-3">
            <button
              className="btn btn-sm text-dark fw-bold fs-3 w-50 "
              style={
                optionsModal
                  ? { backgroundColor: "#2b2b40", transition: "linear .15s" }
                  : { backgroundColor: "#1e1e2d", transition: "linear .15s" }
              }
              onClick={() => toggleContent("take-picture")}
            >
              Tirar Foto
            </button>

            <button
              className="btn btn-sm text-dark fw-bold fs-3 w-50"
              style={
                optionsModal
                  ? { backgroundColor: "#1e1e2d", transition: "linear .15s" }
                  : { backgroundColor: "#2b2b40", transition: "linear .15s" }
              }
              onClick={() => toggleContent("upload-image")}
            >
              Fazer Upload
            </button>
          </div>

          {showCamera ? (
            <Modal.Body>
              <Webcam
                className="w-100 rounded"
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/png"
              />
            </Modal.Body>
          ) : (
            <Modal.Body className="d-flex justify-content-center">
              <InputFile
                className="min-h-120px w-100 h-150px form-control form-control-lg text-center"
                name="profile_image"
                onSelectImage={handleSelectImage}
              />
            </Modal.Body>
          )}
          <Modal.Footer>
            <div className="d-flex gap-5">
              {optionsModal ? (
                <button className="btn btn-success" onClick={capture}>
                  Tirar Foto
                </button>
              ) : (
                <button className="btn btn-success" onClick={uploadImage}>
                  Salvar Upload
                </button>
              )}
              <button
                className="btn btn-sm btn-secondary text-white"
                onClick={() => {
                  setShowCamera(false);
                  setModalCamera(false);
                }}
              >
                Fechar
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default WebCamPicture;